export default {
  setLoading: (state, loading) => (state.loading = loading),
  setOrders: (state, orders) => (state.orders = orders),
  setTotalOrders: (state, totalOrders) => (state.totalOrders = totalOrders),
  setCustomerOrders: (state, customerOrders) =>
    (state.customerOrders = customerOrders),
  setTotalCustomerOrders: (state, totalCustomerOrders) =>
    (state.totalCustomerOrders = totalCustomerOrders),
};
